// src/pages/admin/AdminOrders.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("all");

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get("/admin/orders");
    setOrders(res.data || []);
  };

  const filtered =
    status === "all"
      ? orders
      : orders.filter((o) => o.status === status);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">All Orders</h1>

      <select
        className="input-glass max-w-xs"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="all">All Status</option>
        <option value="pending">Pending</option>
        <option value="processing">Processing</option>
        <option value="completed">Completed</option>
        <option value="cancelled">Cancelled</option>
        <option value="refunded">Refunded</option>
      </select>

      <div className="card-glass overflow-x-auto">
        <table className="table-glass">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>User</th>
              <th>Service ID</th>
              <th>Service</th>
              <th>Qty</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((o) => (
              <tr key={o._id}>
                <td>#{o._id.slice(-6)}</td>
                <td>{o.user?.email || "—"}</td>
                <td>{o.service?.providerServiceId || "-"}</td>
                <td>{o.service?.name}</td>
                <td>{o.quantity}</td>
                <td>₹{o.amount}</td>
                <td>
                  <span className={`chip chip-${o.status}`}>
                    {o.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
